/* eslint-disable */
export default {
  title: '기록',
} as const;

// @key: @#@"title"@#@ @source: @#@"History"@#@
